var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Utils
import { css } from 'styled-components';
import { SplitButtonStylePropertiesByVariantAndSize } from '../types/SplitButtonStylePropertiesByVariantAndSize';
/**
 * @description Ad-hoc util to retrieve outlined styles depending on the size. This is due to a style constraint
 *              that requires the child buttons to be slightly smaller to account for a border on the outer split button
 *              container. The other style variants do not require this style change.
 */
export var getSplitButtonStylesByVariantAndSize = function (styleVariant, size) {
    if (styleVariant === void 0) { styleVariant = 'default'; }
    var _a = SplitButtonStylePropertiesByVariantAndSize[styleVariant][size], height = _a.height, childHeightOverride = _a.childHeightOverride;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: ", ";\n    border-radius: ", ";\n\n    & > * {\n      height: ", ";\n    }\n  "], ["\n    height: ", ";\n    border-radius: ", ";\n\n    & > * {\n      height: ", ";\n    }\n  "])), height, height && '4px', childHeightOverride);
};
var templateObject_1;
//# sourceMappingURL=getSplitButtonStylesByVariantAndSize.js.map